import constants from "constants";
import {
  CLEAR_ADD_TO_CALLENDAR_LINKS,
  GET_ADD_TO_CALLENDAR_LINKS,
  SET_ADD_TO_CALLENDAR_LINKS,
  ADMIN_CREATE_SYSTEM_FEEDBACKS,
  ADMIN_DELETE_SYSTEM_FEEDBACKS,
  ADMIN_GET_SYSTEM_FEEDBACK_BY_ID,
  ADMIN_UPDATE_SYSTEM_FEEDBACKS,
  CLEAR_SYSTEM_FEEDBACKS,
  SET_SYSTEM_FEEDBACK,
} from "../constants/actions";

const {
  SEARCH_WEBINARS_TERMS,
  SAVE_GALLERY,
  GET_GALLERY,
  TOGGLE_GALLERY,
  ADD_GALLERY,
  PUT_GALLERY,
  DELETE_GALLERY,
  ADD_WEBINARS,
  GET_QUESTIONS_ON_WEBINAR,
  SAVE_QUESTIONS_ON_WEBINAR,
  UPCOMING_WEBINARS,
  CURRENT_WEBINARS,
  PREVIOUS_WEBINARS,
  ADD_USERS_WEBINARS,
  UPDATE_WEBINAR,
  SET_TEMP_WEBINAR,
  SAVE_SEARCHED_WEBINARS_TERMS,
  CLEAN_WEBINARS,
  CLEAN_USERS_WEBINARS,
  CREATE_WEBINAR_SAGA,
  LOAD_ADMIN_WEBINARS_SAGA,
  // LOAD_ADMIN_WEBINAR_SAGA,
  ADD_ADMIN_WEBINARS,
  UPDATE_WEBINAR_SAGA,
  UPDATE_WEBINAR_SAGA_WITH_SPEAKER,
  DELETE_WEBINAR_SAGA,
  ADMIN_DELETE_WEBINARS_SAGA,
  LOAD_ADMIN_DASHBOARD_WEBINARS_SAGA,
  ADD_ADMIN_DASHBOARD_WEBINARS,
  LOAD_ADMIN_USRES_WEBINARS_SAGA,
  LOAD_SUBSCRIBED_USERS_SAGA,
  ADD_ADMIN_USRES_WEBINARS,
  SAVE_SEARCHED_WEBINARS,
  SET_WEBINARS,
  RELOAD_ALL_DASHBOARD_WEBINARS_SAGA,
  USER_WEBINARS_AVAILABLE_YEARS,
  LOAD_WEBINARS_AVAILABLE_YEARS_SAGA,
  SET_USERS_WEBINARS,
  LOAD_WEBINAR_SUBSCRIPTION,
  ADD_ADMIN_USRES_WEBINARS_SESSIONS,
  ADD_ADMIN_USERS_NEWSLETTER_WEBINARS,
  LOAD_ADMIN_USERS_WEBINARS_NEWSLETTER_SAGA,
  SEARCH_WEBINARS,
  CLEAR_TEMP_WEBINAR,
  GET_SYSTEM_FEEDBACKS,
  SET_SYSTEM_FEEDBACKS,
  ADMIN_GET_SYSTEM_FEEDBACKS,
} = constants;

export const addWebinars = (webinarType, page, webinars, pages, count) => ({
  type: ADD_WEBINARS,
  webinarType,
  page,
  payload: webinars,
  pages,
  count,
});

export const setWebinars = (webinarType, values, count, page, pages) => ({
  type: SET_WEBINARS,
  webinarType,
  payload: values,
  count,
  page,
  pages,
});

export const updateWebinar = (webinar) => ({
  type: UPDATE_WEBINAR,
  payload: {
    webinar,
  },
});

export const setTempWebinar = (webinar) => ({
  type: SET_TEMP_WEBINAR,
  payload: {
    webinar,
  },
});

export const addUsersWebinars = (
  page,
  webinarType,
  webinars,
  years,
  pages,
  cpds = 0
) => ({
  type: ADD_USERS_WEBINARS,
  page,
  pages,
  webinarType,
  payload: {
    pages,
    webinars,
    cpds,
    years,
  },
});

export const setUsersWebinars = (
  page,
  webinarType,
  webinars,
  years,
  pages,
  cpds = 0
) => ({
  type: SET_USERS_WEBINARS,
  page,
  pages,
  webinarType,
  payload: {
    pages,
    webinars,
    cpds,
    years,
  },
});

export const reloadDashboardWebinars = (params) => ({
  type: RELOAD_ALL_DASHBOARD_WEBINARS_SAGA,
  params,
});

export const cleanWebinars = () => ({
  type: CLEAN_WEBINARS,
});

export const cleanUsersWebinars = () => ({
  type: CLEAN_USERS_WEBINARS,
});

export const createWebinarSaga = (webinar) => ({
  type: CREATE_WEBINAR_SAGA,
  webinar,
});

export const updateWebinarSaga = (webinar) => ({
  type: UPDATE_WEBINAR_SAGA,
  webinar,
});

export const updateWebinarSagaWithSpeaker = (webinar) => ({
  type: UPDATE_WEBINAR_SAGA_WITH_SPEAKER,
  webinar,
});

export const deleteWebinarSaga = (webinar) => ({
  type: DELETE_WEBINAR_SAGA,
  webinar,
});

export const loadAdminWebinarsSaga = (page = 1, query = {}) => ({
  type: LOAD_ADMIN_WEBINARS_SAGA,
  query,
  page,
});

// export const loadAdminWebinarSaga = (webinar_id) => ({
//   type: LOAD_ADMIN_WEBINAR_SAGA,
//   webinar_id
// })

export const loadAdminUsersWebinarsSaga = (webinarId) => ({
  type: LOAD_ADMIN_USRES_WEBINARS_SAGA,
  webinarId,
});

export const loadAdminUsersWebinarsNewsletterSaga = (webinarId, page) => ({
  type: LOAD_ADMIN_USERS_WEBINARS_NEWSLETTER_SAGA,
  webinarId,
  page,
});

export const addAdminUsersWebinars = (values, count) => ({
  type: ADD_ADMIN_USRES_WEBINARS,
  payload: {
    values,
    count,
  },
});

export const addAdminUsersWebinarsSessions = (values, count) => ({
  type: ADD_ADMIN_USRES_WEBINARS_SESSIONS,
  payload: {
    values,
    count,
  },
});
export const addAdminUsersNewsletterWebinars = (
  values,
  count,
  total_pages
) => ({
  type: ADD_ADMIN_USERS_NEWSLETTER_WEBINARS,
  payload: {
    values,
    count,
    total_pages,
  },
});

export const addAdminWebinars = (
  values,
  count,
  page,
  total_pages,
  query = {}
) => ({
  type: ADD_ADMIN_WEBINARS,
  payload: {
    values,
    count,
    page,
    total_pages,
    query,
  },
});

export const adminDeleteWebinarSaga = (webinar_ids) => ({
  type: ADMIN_DELETE_WEBINARS_SAGA,
  webinar_ids,
});

export const loadAdminAdminDashboardWebinarsSaga = (page, params) => ({
  type: LOAD_ADMIN_DASHBOARD_WEBINARS_SAGA,
  page,
  params,
});

export const addAdminDashboardWebinars = (
  values,
  count,
  page,
  total_pages,
  total_users
) => ({
  type: ADD_ADMIN_DASHBOARD_WEBINARS,
  payload: {
    values,
    count,
    page,
    total_pages,
    total_users,
  },
});

export const loadWebinarSubscription = (subscriptionEvent) => ({
  type: LOAD_WEBINAR_SUBSCRIPTION,
  payload: {
    subscriptionEvent,
  },
});

export const addUserWebinarsAvailableYears = (userWebinarsAvailableYears) => ({
  type: USER_WEBINARS_AVAILABLE_YEARS,
  payload: {
    userWebinarsAvailableYears,
  },
});

export const loadWebinarsAvailableYearsSaga = () => ({
  type: LOAD_WEBINARS_AVAILABLE_YEARS_SAGA,
});

export const searchWebinars = (searchString) => ({
  type: SEARCH_WEBINARS,
  payload: {
    searchString,
  },
});

export const searchWebinarsTerms = (searchString) => ({
  type: SEARCH_WEBINARS_TERMS,
  payload: {
    searchString,
  },
});

export const saveSearchedWebinars = (webinars) => ({
  type: SAVE_SEARCHED_WEBINARS,
  payload: {
    webinars,
  },
});

export const saveSearchedWebinarsTerms = (terms) => ({
  type: SAVE_SEARCHED_WEBINARS_TERMS,
  payload: {
    terms,
  },
});

export const getQuestionsOnWebinar = (id, page) => ({
  type: GET_QUESTIONS_ON_WEBINAR,
  payload: {
    id,
    page,
  },
});

export const saveQuestionsOnWebinar = (questionsWebinar) => ({
  type: SAVE_QUESTIONS_ON_WEBINAR,
  payload: {
    questionsWebinar,
  },
});

export const getGallery = (meta) => ({
  type: GET_GALLERY,
  payload: {
    meta,
  },
});

export const saveGallery = (gallery) => ({
  type: SAVE_GALLERY,
  payload: {
    gallery,
  },
});

export const addGallery = (image) => ({
  type: ADD_GALLERY,
  payload: {
    image,
  },
});
export const putGallery = (id, data) => ({
  type: PUT_GALLERY,
  payload: {
    id,
    data,
  },
});

export const deleteGallery = (id) => ({
  type: DELETE_GALLERY,
  payload: {
    id,
  },
});
export const toggleGallery = () => ({
  type: TOGGLE_GALLERY,
});

export const clearTempWebinar = () => ({
  type: CLEAR_TEMP_WEBINAR,
});

export const getAddToCalendarLinks = (payload) => ({
  type: GET_ADD_TO_CALLENDAR_LINKS,
  payload,
});

export const setAddToCalendarLinks = (payload) => ({
  type: SET_ADD_TO_CALLENDAR_LINKS,
  payload,
});

export const clearAddToCalendarLinks = (payload) => ({
  type: CLEAR_ADD_TO_CALLENDAR_LINKS,
  payload,
});

export const getSystemFeedbacks = (payload) => ({
  type: GET_SYSTEM_FEEDBACKS,
  payload,
});

export const getAdminSystemFeedbacks = (payload) => ({
  type: ADMIN_GET_SYSTEM_FEEDBACKS,
  payload,
});

export const setSystemFeedbacks = (payload) => ({
  type: SET_SYSTEM_FEEDBACKS,
  payload,
});

export const clearSystemFeedbacks = (payload) => ({
  type: CLEAR_SYSTEM_FEEDBACKS,
  payload,
});

export const createAdminSystemFeedback = (payload) => ({
  type: ADMIN_CREATE_SYSTEM_FEEDBACKS,
  payload,
});

export const getAdminSystemFeedbackById = (payload) => ({
  type: ADMIN_GET_SYSTEM_FEEDBACK_BY_ID,
  payload,
});

export const setAdminSystemFeedback = (payload) => ({
  type: SET_SYSTEM_FEEDBACK,
  payload,
});

export const updateAdminSystemFeedback = (payload) => ({
  type: ADMIN_UPDATE_SYSTEM_FEEDBACKS,
  payload,
});

export const deleteAdminSystemFeedbacks = (payload) => ({
  type: ADMIN_DELETE_SYSTEM_FEEDBACKS,
  payload,
});



// WEBPACK FOOTER //
// ./src/actions/webinars.js